import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _find from 'lodash/find';
import { Coupon } from 'commons/models/coupon';

import { AppContext } from 'commons-ui';

import useService from '../../utils/useService';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import { UserlistData } from '../../utils/constants';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateCoupon, requestAddUserlist } = useService();

	const createCoupon = (createdData: { couponData: Coupon; userListData?: UserlistData }) => {
		setShowLoader(true);

		const { couponData, userListData } = createdData;

		requestCreateCoupon(app.appName, { ...couponData, isDisabled: true }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the coupon', { type: 'error' });

					setShowLoader(false);
					return;
				}

				if (userListData) {
					requestAddUserlist(app.appName, userListData).then(
						(userlistRes) => {
							const error = _find(userlistRes, (item) => item.status !== 200 || !item.data.success);
							if (error) {
								showAlert(
									`Error: Coupon was successfully created. Error occured while adding userlist. Please edit the coupon to add the list again`,
									{ type: 'error' }
								);
							} else {
								showAlert('Record created');
							}
							setShowLoader(false);
							history.goBack();
						},
						() => {
							showAlert(
								`Error: Coupon was successfully created. Error occured while adding userlist. Please edit the coupon to add the list again`,
								{ type: 'error' }
							);
							setShowLoader(false);
							history.goBack();
						}
					);
				} else {
					showAlert('Record created');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		createCoupon(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: getFormDefaults(), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
